import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/games.svg'
import _imports_1 from '@/assets/icons/streams.svg'
import _imports_2 from '@/assets/icons/news.svg'


const _withScopeId = n => (_pushScopeId("data-v-db726db4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "mobile-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "section-item",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'Games' })), ["stop"]))
    }, _hoisted_3),
    _createElementVNode("div", {
      class: "section-item section-item-middle",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'Streams' })), ["stop"]))
    }, _hoisted_5),
    _createElementVNode("div", {
      class: "section-item",
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'News' })), ["stop"]))
    }, _hoisted_7),
    _createElementVNode("div", {
      class: "section-item-mobile",
      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'Games' })), ["stop"]))
    }, _hoisted_9),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", {
        class: "section-item-mobile",
        style: {"margin-right":"5px"},
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'Streams' })), ["stop"]))
      }, _hoisted_12),
      _createElementVNode("div", {
        class: "section-item-mobile",
        style: {"margin-left":"5px"},
        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'News' })), ["stop"]))
      }, _hoisted_14)
    ])
  ]))
}